export default function WhatsApp() {
    return (
        <>
            <div className="WhatsApp">
                <a href="https://wa.me/923214264000?text=Hello How We can help you?" target="_blank" rel="noopener noreferrer">
                    <div className="Add-Prescription">
                        Add Prescription
                    </div>
                    <div className="WhatsApp-logo">
                        <i className="fab fa-whatsapp"></i>
                    </div>
                </a>
            </div>
        </>
    );
}